
const hostname = window.location.hostname;
const port = window.location.port;

const isDevelopment = 
  hostname === 'localhost' || 
  hostname === '127.0.0.1' || 
  port === '3000' ||
  hostname.startsWith('192.168.') || 
  hostname.startsWith('10.') || 
  hostname.startsWith('172.');

const BACKEND_PORT = isDevelopment ? ':9001' : '';

export const API_BASE = `${window.location.protocol}//${hostname}${BACKEND_PORT}/api`;
export const UPLOADS_URL = `${window.location.protocol}//${hostname}${BACKEND_PORT}`;

// CLÉ PUBLIQUE STRIPE (À remplacer par la vraie clé de test/prod)
export const STRIPE_PUBLIC_KEY = 'pk_test_51SgjueCjc9RdLPmo3OsrCAphzdC1Nyoi3YDRTnNYBKkCpt9XxX8bP2lQZX7GU82RBqwsEcnX3ZS6onRj96yxVHnX00YtuvKQnV';

export const getImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('blob:')) return path;
  if (path.startsWith('http')) return path;
  return `${UPLOADS_URL}${path}`;
};
